import {api} from "./api";


export  const tabConfigApi ={
    getTabConfig : () => api.get("/api/tab-config"),
    createTabConfig : (data) => api.post("/api/tab-config" , data)
}